import type { User } from "../api/v2";
import logo from "../images/duolingo-logo.svg";
import styles from "../styles/TopBar.module.scss";

import Avatar from "./Avatar";

export interface Props {
  user?: User;
}

const TopBar = ({ user }: Props) => (
  <div className={styles.wrap}>
    <div className={styles["duolingo-icon-container"]}>
      <a href="https://www.duolingo.com/learn">
        <img className={styles["duolingo-icon"]} src={logo} />
      </a>
      <h1 className={styles["language-challenge-header-text"]}>
        learning challenge
      </h1>
    </div>
    {user && <Avatar className={styles.avatar} user={user} />}
  </div>
);
export default TopBar;
